// {{ }} pill; the insert logic stays with the field owner (caret handling
// differs per field type).

import { FC } from 'react'
import { useTranslate } from 'react-admin'
import ButtonBase from '@mui/material/ButtonBase'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { themeColor } from '../../../layout/theme/color'
import { MONO_FONT } from '../config/jsonEditing'

const ExpressionInsertPill: FC<{ onInsert: () => void }> = ({ onInsert }) => {
  const translate = useTranslate()
  return (
    <Tooltip title={translate('workflow.config.insertExpressionHelp')}>
      <ButtonBase
        onClick={onInsert}
        // Keep focus (and caret) in the target field while clicking.
        onMouseDown={(e) => e.preventDefault()}
        sx={{
          'display': 'inline-flex',
          'alignItems': 'center',
          'gap': 0.5,
          'px': 0.75,
          'py': 0.25,
          'borderRadius': '6px',
          'border': `1px solid ${themeColor.slate20}`,
          'color': themeColor.slate50,
          'transition': 'all 120ms ease',
          '&:hover': { borderColor: themeColor.slate40, color: themeColor.slate60 },
        }}
      >
        <Typography
          component="span"
          sx={{ fontSize: '0.65rem', fontWeight: 700, lineHeight: 1, fontFamily: MONO_FONT }}
        >
          {'{{ }}'}
        </Typography>
      </ButtonBase>
    </Tooltip>
  )
}

export default ExpressionInsertPill
